var cov_1m628xcq2x = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Progress/analyzeColor.ts",
      hash = "6cf3c5be7df88c218247b1fe674d8e59f3472841",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Progress/analyzeColor.ts",
    statementMap: {
      "0": {
        start: {
          line: 4,
          column: 2
        },
        end: {
          line: 6,
          column: 3
        }
      },
      "1": {
        start: {
          line: 5,
          column: 4
        },
        end: {
          line: 5,
          column: 79
        }
      },
      "2": {
        start: {
          line: 8,
          column: 2
        },
        end: {
          line: 13,
          column: 10
        }
      },
      "3": {
        start: {
          line: 9,
          column: 20
        },
        end: {
          line: 9,
          column: 59
        }
      },
      "4": {
        start: {
          line: 11,
          column: 6
        },
        end: {
          line: 11,
          column: 41
        }
      },
      "5": {
        start: {
          line: 12,
          column: 6
        },
        end: {
          line: 12,
          column: 14
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 3,
            column: 15
          },
          end: {
            line: 3,
            column: 16
          }
        },
        loc: {
          start: {
            line: 3,
            column: 37
          },
          end: {
            line: 14,
            column: 1
          }
        },
        line: 3
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 9,
            column: 10
          },
          end: {
            line: 9,
            column: 11
          }
        },
        loc: {
          start: {
            line: 9,
            column: 20
          },
          end: {
            line: 9,
            column: 59
          }
        },
        line: 9
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 10,
            column: 12
          },
          end: {
            line: 10,
            column: 13
          }
        },
        loc: {
          start: {
            line: 10,
            column: 35
          },
          end: {
            line: 13,
            column: 5
          }
        },
        line: 10
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 4,
            column: 2
          },
          end: {
            line: 6,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 4,
            column: 2
          },
          end: {
            line: 6,
            column: 3
          }
        }, {
          start: {
            line: 4,
            column: 2
          },
          end: {
            line: 6,
            column: 3
          }
        }],
        line: 4
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    b: {
      "0": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

export default (function (color) {
  cov_1m628xcq2x.f[0]++;
  cov_1m628xcq2x.s[0]++;

  if (color.from) {
    cov_1m628xcq2x.b[0][0]++;
    cov_1m628xcq2x.s[1]++;
    return [{
      pos: '0%',
      color: color.from
    }, {
      pos: '100%',
      color: color.to
    }];
  } else {
    cov_1m628xcq2x.b[0][1]++;
  }

  cov_1m628xcq2x.s[2]++;
  return Object.keys(color).sort(function (a, b) {
    cov_1m628xcq2x.f[1]++;
    cov_1m628xcq2x.s[3]++;
    return window.parseInt(a) - window.parseInt(b);
  }).reduce(function (p, v) {
    cov_1m628xcq2x.f[2]++;
    cov_1m628xcq2x.s[4]++;
    p.push({
      pos: v,
      color: color[v]
    });
    cov_1m628xcq2x.s[5]++;
    return p;
  }, []);
});